export default __webpack_public_path__ + "static/media/BOOK 1 - 56680 - Máq. 14ton.801ebdf4.pdf";